import { Database, ref, set } from 'firebase/database';
import { LessonStatus } from '@opanuj/shared/types';

export const lessonStatusUpdate = async (
	database: Database,
	{ id, status }: { id: string, status: LessonStatus }
): Promise<void> => {
	return set(ref(database, `lessons/${id}/status`), status);
};
